
import IdeaCard, { Idea } from "@/components/IdeaCard";

interface IdeasListProps {
  ideas: Idea[];
  onSaveIdea: (idea: Idea) => void;
}

export function IdeasList({ ideas, onSaveIdea }: IdeasListProps) {
  // Sort ideas by difficulty with easy first, then medium, then hard
  const sortedIdeas = [...ideas].sort((a, b) => {
    const difficultyOrder = { "easy": 0, "medium": 1, "hard": 2 };
    return difficultyOrder[a.difficulty] - difficultyOrder[b.difficulty];
  });

  return (
    <div className="mt-4">
      <h2 className="text-xl font-semibold mb-4">Creative Activities</h2>
      <div className="space-y-6">
        {sortedIdeas && sortedIdeas.length > 0 ? (
          sortedIdeas.map((idea) => (
            <IdeaCard 
              key={idea.id} 
              idea={idea}
              onSave={onSaveIdea}
            />
          ))
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            No ideas were generated. Please try again with a different image.
          </div>
        )}
      </div>
    </div>
  );
}
